import { Typography } from "@mui/material"

export function SkillMapHeaderLabel({ children, align }) {
    return (
        <Typography variant="subtitle2" color="text.secondary" align={align}>
            {children}
        </Typography>
    )
}
